import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

/**
 * Main Vuex Store
 */
const store = new Vuex.Store({
  state: {
    // Access Token
    accessToken: '',
    idToken: '',
    MFA: false,
    refreshToken: '',
    user : null,
    areAccountRequiredFieldsFilled : true,
    migratedAdmin : false,
	  isLoggedIn: false,
    blogItems: [],
    newsItems: [],
    whitePaperItems: [],
    screenWidth: null,
  },
  mutations: {
    setLoggedIn: (state, value) => {
      state.isLoggedIn = value
    },
    setAccessToken: (state, value) => {
      state.accessToken = value
    },
    setIdToken: (state, value) => {
      state.idToken = value
    },
    setMFA: (state, value) => {
      state.MFA = value
    },
    setRefreshToken: (state, value) => {
      state.refreshToken = value
    },
    setUser: (state, value) => {
      state.user = value
    },
    setAreAccountRequiredFieldsFilled: (state, value) => {
      state.areAccountRequiredFieldsFilled = value
    },
    setMigratedAdmin : (state, value) =>{
      state.migratedAdmin = value
    },
    setBlogItems: (state, value) => {
      state.blogItems = value;
    },
    setNewsItems: (state, value) => {
      state.newsItems = value;
    },
    setWhitePaperItems: (state, value) => {
      state.whitePaperItems = value;
    },
    setScreenWidth: (state, value) => {
      state.screenWidth = value;
    },
  },
  getters: {
    getAccessToken: (state) => state.accessToken,
    getIdToken: (state) => state.idToken,
    getMFA: (state) => state.MFA,
    getRefreshToken: (state) => state.refreshToken,
    getUser: (state) => state.user,
    getAreAccountRequiredFieldsFilled: (state) => state.areAccountRequiredFieldsFilled,
    getMigratedAdmin: (state) => state.migratedAdmin,
	  getLoggedIn: (state) => state.isLoggedIn,
    getBlogItems: (state) => state.blogItems,
    getNewsItems: (state) => state.newsItems,
    getWhitePaperItems: (state) => state.whitePaperItems,
    getScreenWidth: (state) => state.screenWidth,
  },
  actions: {
    // Asynchronous
    setAccessToken: ({commit, state}, value) => {
      commit('setAccessToken', value)
      return state.accessToken
    },
    setIdToken: ({commit, state}, value) => {
      commit('setIdToken', value)
      return state.idToken
    },
    setMFA: ({commit, state}, value) => {
      commit('setMFA', value)
      return state.MFA
    },
    setRefreshToken: ({commit, state}, value) => {
      commit('setRefreshToken', value)
      return state.refreshToken
    },
    setUser: ({commit, state}, value) => {
      commit('setUser', value)
      return state.user
    },
    setAreAccountRequiredFieldsFilled: ({commit, state}, value) => {
      commit('setAreAccountRequiredFieldsFilled', value)
      return state.setAreAccountRequiredFieldsFilled
    },
    setMigratedAdmin : ({commit, state}, value) =>{
      commit('setMigratedAdmin', value)
      return state.migratedAdmin
    },
	  setLoggedIn : ({commit, state}, value) =>{
      commit('setLoggedIn', value)
      return state.isLoggedIn
    },
    setBlogItems: ({commit, state}, value) => {
      commit('setBlogItems', value)
      return state.blogItems;
    },
    setNewsItems: ({commit, state}, value) => {
      commit('setNewsItems', value)
      return state.newsItems;
    },
    setWhitePaperItems: ({commit, state}, value) => {
      commit('setWhitePaperItems', value);
      return state.whitePaperItems;
    },
    setScreenWidth: ({commit, state}, value) => {
      commit('setScreenWidth', value);
      return state.screenWidth;
    }
  },
  plugins: [createPersistedState()],
})

export default store
